'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'
import ServerError from '@/app/components/Layout/ServerError'

export default function GlobalError({ error }) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="es">
      <body>
        <section className="flex items-center justify-center w-full py-24 overflow-hidden">
          <ServerError />
        </section>
      </body>
    </html>
  )
}
